import React from 'react';
import { View, Text, Platform } from 'react-native';
import { useTheme } from '../../../../theme/useTheme';

const LoadingMessage: React.FC = () => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';

  return (
    <View style={{ padding: 16, alignItems: 'center', justifyContent: 'center' }}>
      <Text style={{ fontSize: 16, color: isDark ? colors.brand.primary : '#0066CC' }}>
        Loading employees...
      </Text>
    </View>
  );
};

export default LoadingMessage;
